/* Dark luxury product theme — variant selection */
(function () {
  'use strict';

  function init(form) {
    var select = form.querySelector('#ph-variant-select');
    if (!select) return;

    var priceEl = document.getElementById('ph-price');
    var buyBtn = form.querySelector('.ph-btn--buy');
    var groups = form.querySelectorAll('.ph-option__values');
    if (!groups.length) {
      // single-variant product, nothing to wire up
      return;
    }

    // current selection per option position
    var options = [];
    groups.forEach(function (g) {
      var pos = parseInt(g.getAttribute('data-option-position'), 10);
      var sel = g.querySelector('.ph-swatch.is-selected') || g.querySelector('.ph-swatch');
      options[pos] = sel ? sel.getAttribute('data-option-value') : null;
    });

    function findVariant() {
      var opts = select.options;
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        var match = true;
        for (var p = 1; p <= options.length; p++) {
          if (options[p] == null) continue;
          if (o.getAttribute('data-option' + p) !== options[p]) { match = false; break; }
        }
        if (match) return o;
      }
      return null;
    }

    function update() {
      var variant = findVariant();
      if (!variant) {
        if (buyBtn) { buyBtn.setAttribute('disabled', 'disabled'); buyBtn.querySelector('span').textContent = 'Unavailable'; }
        return;
      }
      select.value = variant.value;
      if (priceEl && variant.getAttribute('data-price')) {
        priceEl.textContent = variant.getAttribute('data-price');
      }
      if (buyBtn) {
        if (variant.disabled) {
          buyBtn.setAttribute('disabled', 'disabled');
          buyBtn.querySelector('span').textContent = 'Sold Out';
        } else {
          buyBtn.removeAttribute('disabled');
          buyBtn.querySelector('span').textContent = buyBtn.getAttribute('data-label') || buyBtn.querySelector('span').textContent;
        }
      }
    }

    // remember default label
    if (buyBtn) buyBtn.setAttribute('data-label', buyBtn.querySelector('span').textContent);

    groups.forEach(function (g) {
      var pos = parseInt(g.getAttribute('data-option-position'), 10);
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('.ph-swatch');
        if (!btn) return;
        g.querySelectorAll('.ph-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        options[pos] = btn.getAttribute('data-option-value');
        var label = form.querySelector('[data-current-for="' + pos + '"]');
        if (label) { label.textContent = btn.getAttribute('data-option-value'); }
        update();
      });
    });

    update();
  }

  // ---- Quantity stepper (product hero) ----
  function stepInput(input, delta, min) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) { v = min; }
    v += delta;
    if (v < min) { v = min; }
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initHeroQty() {
    var wrap = document.querySelector('#ph-product-form .ph-qty');
    if (!wrap) return;
    var input = wrap.querySelector('.ph-qty__input');
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.ph-qty__btn');
      if (!btn) return;
      stepInput(input, btn.getAttribute('data-qty') === 'plus' ? 1 : -1, 1);
    });
  }

  // ---- Cart page quantity steppers (auto-submit update) ----
  function initCartQty() {
    var form = document.querySelector('.ph-cart');
    if (!form) return;
    var updateBtn = form.querySelector('button[name="update"]');
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.ph-qty__btn');
      if (!btn) return;
      var input = btn.parentNode.querySelector('.ph-qty__input');
      stepInput(input, btn.getAttribute('data-cart-qty') === 'plus' ? 1 : -1, 0);
      if (updateBtn && form.requestSubmit) {
        form.requestSubmit(updateBtn);
      } else if (form.submit) {
        form.submit();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('ph-product-form');
    if (form) init(form);
    initHeroQty();
    initCartQty();
  });
})();
